import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceinjejurimidc() {



  const cardData =
  {
    keyword: 'Cab Service in Jejuri MIDC',
    heading: 'Pune Corporate Cars India Private Limited: Cab Service in Jejuri MIDC',
    headingDescription: 'Pune Corporate Cars India Private Limited offers reliable and professional Cab Service in Jejuri MIDC, providing smooth and efficient transportation solutions for factories, manufacturing plants, pharma units, and corporate offices in this key industrial zone. Our fleet of clean, air-conditioned sedans, SUVs, and employee-transport vehicles ensures safe, comfortable, and punctual commuting for employees, supervisors, executives, and visiting clients. With trained chauffeurs, GPS-enabled vehicles, and flexible rental packages, we deliver dependable shift-based transport, dedicated corporate cars, and on-demand executive travel. Whether your company requires daily pick-and-drop, client pickups, or long-term corporate cab services, Pune Corporate Cars India Private Limited ensures high-quality, seamless, and hassle-free mobility tailored to Jejuri MIDC’s industrial requirements.',

    top: 'Top Places to Visit in Pune with Pune Corporate Car',

    "topPlaces": [
    {
      "title": "Hinjewadi Rajiv Gandhi Infotech Park",
      "description": "Hinjewadi Phase 1, 2 and 3 together form Pune’s largest corporate ecosystem, home to global IT companies, MNCs, tech parks, and business hubs. With campuses of Infosys, Wipro, Cognizant, TCS and more, it is Pune’s primary employment corridor. The area has wide roads, 24×7 transport demand, cafes, business hotels, and constant corporate mobility needs — making it one of the busiest routes served by Pune Corporate Cars."
    },
    {
      "title": "Magarpatta Cybercity",
      "description": "Magarpatta Cybercity is a self-sustained corporate township combining IT parks, residential spaces, restaurants, and premium office buildings. Known for its clean, green, and secure environment, it hosts major IT giants like Accenture, Infosys, Capgemini and Barclays. Corporate travel requirements, employee drop services, and daily office commutes make it a major business hub in Pune."
    },
    {
      "title": "Kharadi EON IT Park",
      "description": "EON IT Park is Pune’s fastest-growing commercial destination, filled with high-rise IT towers, premium offices, and multinational companies. Its four major clusters (A, B, C, D) attract thousands of daily employees. With tech companies, co-working spaces, and international business centers, Kharadi is a top route for corporate pick-drop and airport transfers."
    },
    {
      "title": "Viman Nagar Business District",
      "description": "Viman Nagar is a premium corporate and lifestyle hub near Pune Airport, known for its modern business centers, coworking spaces, hotels, and commercial complexes. Major malls, restaurants, and connectivity to Kharadi, Koregaon Park, and Yerwada make it a preferred zone for corporate travel, meetings, and executive cab services."
    },
    {
      "title": "Baner–Balewadi Corporate Hub",
      "description": "Baner and Balewadi have transformed into Pune’s new-age commercial cluster with IT companies, startups, co-working hubs, and premium business towers. It offers a cosmopolitan corporate environment with cafés, boardrooms, and business hotels. The area’s proximity to Hinjewadi makes corporate cab requirements extremely high for daily office mobility."
    },
    {
      "title": "Chakan MIDC Industrial Area",
      "description": "Chakan MIDC is one of India’s biggest industrial and automobile manufacturing clusters, housing companies like Volkswagen, Mercedes-Benz, Bajaj, LG, and Mahindra. With 24×7 transport operations, staff shifts, and inter-plant travel, it is a prime location served by corporate cab services, staff shuttle operations, and industrial commute solutions."
    },
    {
      "title": "Talegaon MIDC",
      "description": "Talegaon MIDC is known for its global manufacturing units, auto plants, and logistics hubs. It hosts companies such as General Motors, L&T, JCB, and POSCO. The area witnesses heavy employee movement and frequent business visits from executives — making structured corporate mobility critical for smooth travel between Pune city and the MIDC."
    },
    {
      "title": "Yerwada Business Corridor",
      "description": "Yerwada is a major commercial zone with corporate towers, business parks, and high-end office spaces like ICC Tech Park and Commerzone. It is a preferred location for corporate meetings, finance companies, and consulting firms. Its close connectivity to the airport and EON makes it a frequent route for corporate cabs and executive travel."
    },
    {
      "title": "Koregaon Park Business & Lifestyle District",
      "description": "Koregaon Park blends premium business centers with high-end lifestyle spaces, cafés, and boutique offices. It attracts startups, creative agencies, international firms, and co-working workspaces. The area is ideal for board meetings, client visits, and VIP travel — heavily relying on professional chauffeur-driven cabs."
    },
    {
      "title": "Pimpri-Chinchwad Industrial Belt",
      "description": "PCMC is one of Pune’s strongest industrial belts, filled with auto, engineering, and manufacturing companies. Areas like Pimpri, Chinchwad, Bhosari, and Nigdi host major factories and R&D centers. With shift-based employee travel and factory visits, corporate cab services remain essential for day-to-day operations."
    }
  ],



"services": [
  {
    "name": "Jejuri MIDC Staff Cab",
    "description": "Jejuri MIDC Staff Cab provides reliable and well-organized daily transportation for employees working in Jejuri’s industrial zone. With AC cabs, shuttle vans, and tempo travellers, the service ensures punctual pickup–drop operations across multiple shifts. Jejuri MIDC Staff Cab is ideal for factories, warehouses, and corporate units requiring safe and dependable staff mobility."
  },
  {
    "name": "Employee Transportation Jejuri",
    "description": "Employee Transportation Jejuri offers structured and safe commuting solutions for workers, technicians, and office staff. The service covers multiple routes and shift timings with GPS-enabled vehicles and professionally trained drivers. Employee Transportation Jejuri helps companies maintain smooth operational productivity through reliable workforce travel."
  },
  {
    "name": "Worker Pickup Drop Jejuri",
    "description": "Worker Pickup Drop Jejuri provides efficient and punctual pickup and drop services for industrial workers across Jejuri MIDC. Supporting early morning, night, and rotational shifts, the service ensures consistent and comfortable daily commute. Worker Pickup Drop Jejuri is essential for industries requiring continuous workforce availability."
  },
  {
    "name": "Company Cab Jejuri MIDC",
    "description": "Company Cab Jejuri MIDC delivers professional transportation services for employees, executives, and supervisors. With a fleet of AC sedans, SUVs, and shuttle vehicles, the service ensures safe, comfortable, and timely travel for corporate requirements. Company Cab Jejuri MIDC is ideal for daily commute, team movement, and official visits."
  },
  {
    "name": "Industrial Shuttle Jejuri",
    "description": "Industrial Shuttle Jejuri offers high-capacity shuttle services for factories and manufacturing units. Designed for bulk employee movement, the service uses vans and minibuses to manage shift-based commuting efficiently. Industrial Shuttle Jejuri provides reliable, economical, and on-time transport for industrial teams."
  },
  {
    "name": "Affordable Cab Jejuri",
    "description": "Affordable Cab Jejuri delivers budget-friendly travel options for companies of all sizes. With shared cabs, fixed-route services, and cost-effective monthly plans, the service ensures safe and economical workforce mobility. Affordable Cab Jejuri helps businesses maintain transportation quality while reducing operational expenses."
  },
  {
    "name": "Business Cab Hire Jejuri",
    "description": "Business Cab Hire Jejuri provides premium sedans and SUVs for corporate executives, managers, and visitors. Ideal for business meetings, site inspections, and intercity travel, the service guarantees AC comfort, clean interiors, and trained chauffeurs. Business Cab Hire Jejuri ensures a professional and smooth travel experience."
  },
  {
    "name": "Monthly Cab Service Jejuri",
    "description": "Monthly Cab Service Jejuri offers long-term cab rental plans with dedicated vehicles assigned to your organization. Perfect for daily travel, managerial movement, and regular office routes, the service provides predictable billing, priority support, and reliable vehicle availability. Monthly Cab Service Jejuri ensures uninterrupted corporate mobility."
  },
  {
    "name": "Best Corporate Cab Jejuri",
    "description": "Best Corporate Cab Jejuri provides top-rated corporate cab services with clean vehicles, disciplined drivers, and excellent punctuality. Designed for corporate teams, supervisors, and administrative staff, the service delivers reliable, comfortable, and safe transportation every day. Best Corporate Cab Jejuri is trusted for high service quality."
  },
  {
    "name": "Outstation Cab Jejuri MIDC",
    "description": "Outstation Cab Jejuri MIDC offers comfortable long-distance travel for executives, employees, and corporate visitors. With AC sedans and SUVs driven by experienced chauffeurs, the service ensures smooth intercity mobility for audits, meetings, inspections, and plant visits. Outstation Cab Jejuri MIDC provides dependable and timely outstation travel."
  },
  {
    "name": "Sedan Cab Jejuri",
    "description": "Sedan Cab Jejuri delivers executive travel with premium AC sedans suitable for daily commute, business visits, and intercity meetings. Clean interiors, comfortable seating, and trained drivers ensure a professional and pleasant travel experience. Sedan Cab Jejuri is perfect for supervisors, managers, and executives."
  },
  {
    "name": "SUV Cab Jejuri",
    "description": "SUV Cab Jejuri provides spacious and comfortable SUV vehicles ideal for long-distance trips, corporate travel, and industrial visits. With strong AC, ample legroom, and smooth suspension, SUV Cab Jejuri ensures a high-class travel experience for corporate teams and guests."
  },
  {
    "name": "Corporate Fleet Jejuri MIDC",
    "description": "Corporate Fleet Jejuri MIDC offers a fully managed fleet of sedans, SUVs, shuttles, and staff vehicles for daily operations. Suitable for employee commute, executive mobility, and inter-factory movement, the service ensures reliable, scalable, and professionally managed corporate transportation."
  },
  {
    "name": "Factory Transport Jejuri",
    "description": "Factory Transport Jejuri provides shuttle vans, minibuses, and shared cabs for workers and industrial staff. Ideal for large-scale manufacturing units, the service ensures timely travel, safe driving, and efficient transport between residential zones and factories. Factory Transport Jejuri supports smooth workforce operations."
  },
  {
    "name": "Staff Shuttle Jejuri",
    "description": "Staff Shuttle Jejuri delivers organized shuttle services across fixed routes for employees traveling to Jejuri MIDC. Designed for large teams, the service ensures punctual commuting with trained drivers and multiple shift coverage. Staff Shuttle Jejuri ensures reliable and cost-effective mass employee transport."
  }
],
"tableData": [
  ["Jejuri MIDC Staff Cab", "Employee Transportation Jejuri"],
  ["Worker Pickup Drop Jejuri", "Company Cab Jejuri MIDC"],
  ["Industrial Shuttle Jejuri", "Affordable Cab Jejuri"],
  ["Business Cab Hire Jejuri", "Monthly Cab Service Jejuri"],
  ["Best Corporate Cab Jejuri", "Outstation Cab Jejuri MIDC"],
  ["Sedan Cab Jejuri", "SUV Cab Jejuri"],
  ["Corporate Fleet Jejuri MIDC", "Factory Transport Jejuri"],
  ["Staff Shuttle Jejuri", ""]
],


  






"whychoose": [
  {
    "WhyChooseheading": "Cab Service in Jejuri MIDC",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited offers reliable and efficient cab services in Jejuri MIDC, ideal for industries, factories, and company staff transportation."
  },
  {
    "WhyChooseheading": "Ideal for Industrial Zone Travel",
    "WhyChoosedescription": "Our services are perfectly suited for employees and executives commuting to various manufacturing units and industrial setups in Jejuri MIDC."
  },
  {
    "WhyChooseheading": "Safe & Well-Maintained Vehicles",
    "WhyChoosedescription": "All cabs are regularly serviced, deeply cleaned, and sanitized to ensure a safe and comfortable journey every day."
  },
  {
    "WhyChooseheading": "Affordable Travel Packages",
    "WhyChoosedescription": "We offer economical monthly and daily packages designed to meet the transportation needs of companies in Jejuri MIDC."
  },
  {
    "WhyChooseheading": "On-Time Pickup & Drop",
    "WhyChoosedescription": "Our transportation team follows strict timing schedules to ensure punctual employee movement for shift-based industries."
  },
  {
    "WhyChooseheading": "Trained & Courteous Drivers",
    "WhyChoosedescription": "Professional drivers familiar with Jejuri MIDC routes ensure safe, smooth, and respectful travel experiences."
  },
  {
    "WhyChooseheading": "24/7 Operational Support",
    "WhyChoosedescription": "Round-the-clock customer service is available for urgent cab needs, route adjustments, or scheduling changes."
  },
  {
    "WhyChooseheading": "Easy & Hassle-Free Booking",
    "WhyChoosedescription": "Booking cab services for Jejuri MIDC is quick, simple, and convenient with Pune Corporate Cars India Private Limited."
  }
]

























  }

const faqData = [
  {
    question: 'Does Pune Corporate Cars India Private Limited provide cab services in Jejuri MIDC?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers reliable and professional cab services for employees and corporate travel in Jejuri MIDC.',
  },
  {
    question: 'How can companies in Jejuri MIDC book cab services?',
    answer: 'Bookings can be made through our website, mobile app, or by contacting our 24×7 corporate support team.',
  },
  {
    question: 'Do you provide employee pickup and drop services in Jejuri MIDC?',
    answer: 'Yes, we offer structured and punctual pickup and drop services for employees working in Jejuri MIDC.',
  },
  {
    question: 'What types of vehicles are available for cab services in Jejuri MIDC?',
    answer: 'We provide hatchbacks, sedans, SUVs, and tempo travellers suitable for staff transportation and corporate travel.',
  },
  {
    question: 'Are monthly or yearly cab contracts available for companies in Jejuri MIDC?',
    answer: 'Yes, we offer flexible and cost-effective monthly and annual cab service contracts for Jejuri MIDC companies.',
  },
  {
    question: 'Are your drivers experienced with Jejuri MIDC routes?',
    answer: 'Absolutely. Our drivers are well-versed with the Jejuri MIDC area, ensuring safe and timely travel.',
  },
  {
    question: 'Do you support shift-based cab services for Jejuri MIDC industries?',
    answer: 'Yes, we support all types of shift operations including night shifts, early morning shifts, and rotational shifts.',
  },
  {
    question: 'What safety and hygiene measures are followed for your cab services?',
    answer: 'All vehicles are sanitized regularly, and drivers follow strict safety and hygiene protocols.',
  },
  {
    question: 'What payment methods are available for cab services in Jejuri MIDC?',
    answer: 'We accept UPI, credit/debit cards, bank transfers, digital wallets, and offer corporate billing options.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Santosh Pawar',
    feedback: 'Pune Corporate Cars India Private Limited provides excellent cab service in Jejuri MIDC. Their punctuality and professionalism stand out.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Manasi Kulkarni',
    feedback: 'Reliable service, polite drivers, and clean vehicles. Perfect cab service for Jejuri MIDC corporate needs.',
    rating: 5,
  },
];

















































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service in Jejuri MIDC",
  "image": "https://www.punecorporatecars.com/assets/images/corporate-cabs-jejuri.jpg", // replace with actual image URL
  "description": "Reliable corporate cab services in Jejuri MIDC, Pune, offering employee transportation, staff shuttles, office and factory pickup/drop, and industrial commute. Pune Corporate Cars India Private Limited provides chauffeur-driven sedans, SUVs, and outstation cabs for companies and industrial units in Jejuri.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",  // update if needed
    "ratingCount": "4400", // update if needed
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1500", // starting price, adjust if needed
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/cab-service-jejuri-midc"
  }
};







  return (
    <div>
<Helmet>
  <title>Cab Service in Jejuri MIDC | Employee & Industrial Cabs | Pune Corporate Cars India Private Limited</title>

  <meta
    name="description"
    content="Reliable corporate cab services in Jejuri MIDC, Pune, offering employee transportation, staff shuttles, office and factory pickup/drop, and industrial commute. Chauffeur-driven sedans, SUVs, and outstation cabs for companies and industrial units in Jejuri."
  />

  <meta
    name="keywords"
    content="Jejuri MIDC Staff Cab, Employee Transportation Jejuri, Worker Pickup Drop Jejuri, Company Cab Jejuri MIDC, Industrial Shuttle Jejuri, Affordable Cab Jejuri, Business Cab Hire Jejuri, Monthly Cab Service Jejuri, Best Corporate Cab Jejuri, Outstation Cab Jejuri MIDC, Sedan Cab Jejuri, SUV Cab Jejuri, Corporate Fleet Jejuri MIDC, Factory Transport Jejuri, Staff Shuttle Jejuri"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/22.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cabserviceinjejurimidc;